import { gql } from '@apollo/client';

import { issue_fields } from './issues';
import { location_fields, latest_location_fields } from './positionDevice';
import { FR_EQUIPMENT_FIELDS, FR_EQUIPMENT_LIST_FIELDS, FR_EQUIPMENT_TYPE_FIELDS } from './fragments/equipment';
export const equipment_fields = `
  EquipmentId
  Name
  Model
  SerialNbr
  PurchaseVendor
  Count
  EquipmentType {
    EquipmentTypeId
    Name
  }
  EquipmentClass{
    EquipmentClassId
    Name
  }
  Access {
    Read
    Create
    Delete
    Update
  }
  Asset {
    AssetName
    AssetType
  }
  Organization{
    Name
		OrganizationId
  }
  EquipmentStatus {
    Equipped
    Failed
    InStock
  }
  EquipmentLocation {
    __typename
    Lat
    Long
  }
  LatestLocation {
    __typename
    Lat
    Long
  }
  EquipmentCalibration {
    CalibrationDate
    Created
    ExpirationDate
    Updated
  }
  CalibrationDate
  ExpirationDate
  PurchaseDate
  InServiceDate
  OutOfServiceDate`;

export const EQUIPMENT_LIST = 'Equipments {' + equipment_fields + '}';

const issueFields = ' Issues {' + issue_fields + ' }';

const machineEquipment_Fields = `
    MachineEquipmentId
    Machine {
      MachineId
      Name
      SerialNbr
    }
    Equipment {
      EquipmentId
    }`;

const machineEquipment_Block = `MachineEquipment { ` + machineEquipment_Fields + `}`;

export const GET_EQUIPMENT_LOCATIONDATA = gql(
    `
query equipmentById($EquipmentId: Int!, $StartDate: Date!, $EndDate: Date!) {
	equipmentById( data: { EquipmentId: $EquipmentId}) {
  EquipmentId
  EquipmentLocation( data: {Update: true,  StartDate: $StartDate EndDate: $EndDate}) {
    ` +
        location_fields +
        `
  }
	}
}`
);

// EquipmentStatus
export const GET_EQUIPMENTS = gql(
    `query equipments { equipments {` +
        equipment_fields +
        issueFields +
        latest_location_fields +
        machineEquipment_Block +
        `}}`
);

export const GET_EQUIPMENTS_FILTER_COUTZERO = gql(
    `query { equipments(data: {FilterEmpty: true}) { ` + equipment_fields + ` }}`
);

export const GET_EQUIPMENT_TYPES = gql`
    query equipmentType {
        equipmentType {
           ...fr_EquipmentTypeFields
        }
    }
    ${FR_EQUIPMENT_TYPE_FIELDS}
`;

export const GET_EQUIPMENT_CLASSES = gql`
    query equipmentClasses {
        equipmentClasses {
            EquipmentClassId
            Name
        }
    }
`;

export const CREATE_EQUIPMENT = gql(
    `
mutation createEquipment($Name: String!, $Model: String!, $SerialNbr: String, $PurchaseVendor: String, $PurchaseDate: Date!, $InServiceDate: Date!, $OutOfServiceDate: Date, $Count: Int!, , $EquipmentTypeId: Int!, $MachineId: Int, $EquipmentClassId: Int!) {
  createEquipment(data: {
    Name: $Name
    Model: $Model
    SerialNbr: $SerialNbr
    PurchaseVendor: $PurchaseVendor
    PurchaseDate: $PurchaseDate
    OutOfServiceDate: $OutOfServiceDate
    InServiceDate: $InServiceDate
    Count: $Count
    EquipmentTypeId: $EquipmentTypeId
    MachineId: $MachineId
    EquipmentClassId: $EquipmentClassId
  }){` +
        equipment_fields +
        issueFields +
        machineEquipment_Block +
        latest_location_fields +
        `}}`
);

export const DELETE_EQUIPMENT = gql`
    mutation deleteEquipment($EquipmentId: Int!) {
        deleteEquipment(data: { EquipmentId: $EquipmentId })
    }
`;

export const UPDATE_EQUIPMENT = gql(
    `
mutation updateEquipment($EquipmentId: Int!, $Name: String, $Model: String, $SerialNbr: String, $PurchaseVendor: String, $PurchaseDate: Date, $InServiceDate: Date, $Count: Int, $EquipmentTypeId: Int, $EquipmentClassId: Int) {
  updateEquipment(data: {
    EquipmentId: $EquipmentId
    Name: $Name
    Model: $Model
    SerialNbr: $SerialNbr
    PurchaseVendor: $PurchaseVendor
    PurchaseDate: $PurchaseDate
    InServiceDate: $InServiceDate
    Count: $Count
    EquipmentTypeId: $EquipmentTypeId
    EquipmentClassId: $EquipmentClassId
  }){` +
        equipment_fields +
        issueFields +
        machineEquipment_Block +
        latest_location_fields +
        `}}`
);

export const RESOURCE_EQUIPMENT = gql(
    `
mutation machineEquipping($FromMachineId: Int, $ToMachineId: Int, $EquipmentId: Int!, $Count: Int!) {
  machineEquipping(data: {FromMachineId: $FromMachineId, ToMachineId: $ToMachineId, EquipmentId: $EquipmentId, Count: $Count}) 
	{` +
        machineEquipment_Fields +
        `}}`
);

export const GET_EQUIPMENT_ROWS = gql`
    query equipmentRows($From: Int, $To: Int, $Search: String, $EquipmentIds: [Int!]) {
        equipmentRows(
            data: { From: $From, To: $To, Search: $Search, EquipmentIds: $EquipmentIds }
        ) {
            TotalRowCount
            Equipment {
                ...fr_EquipmentListFields
            }
        }
    }
    ${FR_EQUIPMENT_LIST_FIELDS}
`;

export const GET_EQUIPMENT = gql`
    query equipment($EquipmentId: Int!) {
        equipment(data: { EquipmentId: $EquipmentId }) {
            ...fr_EquipmentFields
        }
    }
    ${FR_EQUIPMENT_FIELDS}
`;

export const ARCHIVE_EQUIPMENT = gql`
    mutation archiveEquipment($EquipmentId: Int!) {
        archiveEquipment(data: { EquipmentId: $EquipmentId }) {
            ...fr_EquipmentFields
        }
    }
    ${FR_EQUIPMENT_FIELDS}
`;

export const CREATE_EQ = gql`
    mutation createEquipment(
        $Name: String!
        $Model: String!
        $SerialNbr: String
        $PurchaseVendor: String
        $PurchaseDate: Date!
        $InServiceDate: Date!
        $OutOfServiceDate: Date
        $Count: Int!
        $EquipmentTypeId: Int!
        $MachineId: Int
        $EquipmentClassId: Int!
    ) {
        createEquipment(
            data: {
                Name: $Name
                Model: $Model
                SerialNbr: $SerialNbr
                PurchaseVendor: $PurchaseVendor
                PurchaseDate: $PurchaseDate
                OutOfServiceDate: $OutOfServiceDate
                InServiceDate: $InServiceDate
                Count: $Count
                EquipmentTypeId: $EquipmentTypeId
                MachineId: $MachineId
                EquipmentClassId: $EquipmentClassId
            }
        ) {
            ...fr_EquipmentFields
        }
    }
    ${FR_EQUIPMENT_FIELDS}
`;

export const UPDATE_EQ = gql`
    mutation updateEquipment(
        $EquipmentId: Int!
        $Name: String
        $Model: String
        $SerialNbr: String
        $PurchaseVendor: String
        $PurchaseDate: Date
        $InServiceDate: Date
        $Count: Int
        $EquipmentTypeId: Int
        $EquipmentClassId: Int
        $OrganizationId: Int
    ) {
        updateEquipment(
            data: {
                EquipmentId: $EquipmentId
                Name: $Name
                Model: $Model
                SerialNbr: $SerialNbr
                PurchaseVendor: $PurchaseVendor
                PurchaseDate: $PurchaseDate
                InServiceDate: $InServiceDate
                Count: $Count
                EquipmentTypeId: $EquipmentTypeId
                EquipmentClassId: $EquipmentClassId
                OrganizationId: $OrganizationId
            }
        ) {
            ...fr_EquipmentFields
        }
    }
    ${FR_EQUIPMENT_FIELDS}
`;
